export default {

  status: {
    PENDENCIA_ADM: 1,
    PENDENCIA_JURIDICO: 2,
    SOLICITAR_PERICIA: 3,
    PERICIA_AGENDADA: 4,
    PERICIA_DISPENSADA: 5,
    PERICIA_RECEBIDA: 6,
    NEGADO: 6,
    JURIDICO_DISTRIBUIR: 7,
    EM_ANALISE: 8,
    PAGO: 9,
    PAGO_HONORARIOS: 10,
    INADIMPLENTE: 11,
    NEGADO: 12,
    ARQUIVO: 13,
    CANCELADO: 14,
    CADASTRO: 15,
    JURIDICO_OK: 16,
    ANALISE_JURIDICA: 17,
    PENDENCIA_DOCUMENTAL: 18,
    DISTRIBUIDO: 19, //juridico
  },

  /*this.dropdownStatusProcesso.forEach(item => {
    if (this.formProcesso.statusprocesso_id <= validaProcesso.status.JURIDICO_DISTRIBUIR && item.value <= validaProcesso.status.EM_ANALISE) dados.push(item)
    if (this.formProcesso.statusprocesso_id >= validaProcesso.status.EM_ANALISE) dados.push(item)
  })*/

  statusPorTipoCategoria(tipo, categoria, statusAtual, objStatus) {

    let objStatusRetorno = []

    //tipo processo = 1-Administrativo / 2-Juridico
    if (tipo == 2) {
      objStatus.forEach(item => {
        if (item.value == this.status.PERICIA_AGENDADA) item.text = `${item.text} (INSS)`
      })

      objStatus.forEach(item => {
        //if (item.value == this.status.PERICIA_AGENDADA) item.text = `${item.text} (INSS)`
        if (this.validaStatus_JUR_VAZIO(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_JUR_CADASTRO(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_JUR_PENDENCIA_JURIDICO(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_JUR_PERICIA_AGENDADA(statusAtual, item)) objStatusRetorno.push(item)
        if (this.validaStatus_JUR_JURIDICO_OK(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_JUR_JURIDICO_DISTRIBUIR(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_JUR_DISTRIBUIDO(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_JUR_PAGO_HONORARIOS(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_JUR_NEGADO(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_JUR_ARQUIVO(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_JUR_CANCELADO(statusAtual, item)) objStatusRetorno.push(item) 
      })
      if (!objStatusRetorno.length) {
        objStatus.forEach(item => {
          if (item.value == this.status.CADASTRO) objStatusRetorno.push(item)
          if (item.value == this.status.PENDENCIA_JURIDICO) objStatusRetorno.push(item)
          if (item.value == this.status.PERICIA_AGENDADA) objStatusRetorno.push(item)
          if (item.value == this.status.JURIDICO_OK) objStatusRetorno.push(item)
          if (item.value == this.status.JURIDICO_DISTRIBUIR) objStatusRetorno.push(item)
          if (item.value == this.status.CANCELADO) objStatusRetorno.push(item)
        })
      }
      
    } else {
      objStatus.forEach(item => {
        if (this.validaStatus_ADM_VAZIO(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_ADM_CADASTRO(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_ADM_PENDENCIA_ADM(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_ADM_SOLICITAR_PERICIA(statusAtual, item)) objStatusRetorno.push(item)
        if (this.validaStatus_ADM_PERICIA_AGENDADA(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_ADM_PERICIA_DISPENSADA(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_ADM_PERICIA_RECEBIDA(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_ADM_PENDENCIA_DOCUMENTAL(statusAtual, item)) objStatusRetorno.push(item)
        if (this.validaStatus_ADM_EM_ANALISE(statusAtual, item)) objStatusRetorno.push(item)
        if (this.validaStatus_ADM_PAGO(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_ADM_PAGO_HONORARIOS(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_ADM_ANALISE_JURIDICA(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_ADM_INADIMPLENTE(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_ADM_NEGADO(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_ADM_ARQUIVO(statusAtual, item)) objStatusRetorno.push(item) 
        if (this.validaStatus_ADM_CANCELADO(statusAtual, item)) objStatusRetorno.push(item)
      })
      if (!objStatusRetorno.length) {
        objStatus.forEach(item => {
          if (item.value == this.status.CADASTRO) objStatusRetorno.push(item)
          if (item.value == this.status.PENDENCIA_ADM) objStatusRetorno.push(item)
          if (item.value >= this.status.SOLICITAR_PERICIA && item.value <= this.status.PERICIA_RECEBIDA) objStatusRetorno.push(item)
          if (item.value == this.status.EM_ANALISE) objStatusRetorno.push(item)
          if (item.value == this.status.CANCELADO) objStatusRetorno.push(item)
        })
      }

    }
    return objStatusRetorno
  },

  ehProcessoPericiaAgendada: function (statusprocesso_id) {
    if (statusprocesso_id == status.PERICIA_AGENDADA) return true
    return false
  },
  ehProcessoPericiaRecebida: function (statusprocesso_id) {
    if (statusprocesso_id == status.PERICIA_RECEBIDA) return true
    return false
  },
  ehProcessoPericiaDispensada: function (statusprocesso_id) {
    if (statusprocesso_id == status.PERICIA_DISPENSADA) return true
    return false
  },
  ehProcessoNegado: function (statusprocesso_id) {
    if (statusprocesso_id == status.NEGADO) return true
    return false
  },
  ehProcessoPago: function (statusprocesso_id) {
    if (statusprocesso_id == status.PAGO) return true
    return false
  },
  ehProcessoPagoHonorario: function (statusprocesso_id) {
    if (statusprocesso_id == this.status.PAGO_HONORARIOS || statusprocesso_id == this.status.ANALISE_JURIDICA) return true
    return false
  },
  ehProcessoArquivo: function (statusprocesso_id) {
    if (statusprocesso_id == this.status.ARQUIVO) return true
    return false
  },
  ehProcessoAnaliseJuridico: function (statusprocesso_id) {
    if (statusprocesso_id == this.status.ANALISE_JURIDICA) return true
    return false
  },

  exigirDataPericia: function (processo) {
    let statusproc = processo.statusprocesso_id
    let dispensa = processo.pericia_dispensada

    if (dispensa == false) {
      //ADM
      if (statusproc == this.status.PERICIA_RECEBIDA) return true
      if (statusproc == this.status.PENDENCIA_DOCUMENTAL) return true
      if (statusproc == this.status.EM_ANALISE) return true
      if (statusproc == this.status.PAGO) return true      
      if (statusproc == this.status.INADIMPLENTE) return true
      if (statusproc == this.status.ANALISE_JURIDICA) return true

      if (statusproc == this.status.CANCELADO) return true
      if (statusproc == this.status.CANCELADO) return true
      if (statusproc == this.status.CANCELADO) return true

      //JURIDICO
      if (statusproc == this.status.JURIDICO_DISTRIBUIR) return true
      if (statusproc == this.status.JURIDICO_OK) return true
      if (statusproc == this.status.DISTRIBUIDO) return true


      //COMUM
      if (statusproc == this.status.PERICIA_AGENDADA) return true
      if (statusproc == this.status.PAGO_HONORARIOS) return true
      if (statusproc == this.status.CANCELADO) return true
      if (statusproc == this.status.ARQUIVO) return true
      if (statusproc == this.status.NEGADO) return true
   }

   return false
   
  },

  //Valida e retorno STATUS quando o processo for do tipo ADMINISTRATIVO
  validaStatus_ADM_VAZIO: function (statusAtual, statusItem) {
    if (statusAtual) return false
    if (statusItem.value == this.status.CADASTRO) return true
    if (statusItem.value == this.status.PENDENCIA_ADM) return true
    if (statusItem.value >= this.status.SOLICITAR_PERICIA && statusItem.value <= this.status.PERICIA_RECEBIDA) return true
    if (statusItem.value == this.status.EM_ANALISE) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_ADM_CADASTRO: function (statusAtual, statusItem) {
    if (statusAtual !== this.status.CADASTRO) return false
    if (statusItem.value == this.status.CADASTRO) return true
    if (statusItem.value == this.status.PENDENCIA_ADM) return true
    if (statusItem.value >= this.status.SOLICITAR_PERICIA && statusItem.value <= this.status.PERICIA_RECEBIDA) return true
    if (statusItem.value == this.status.EM_ANALISE) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_ADM_PENDENCIA_ADM: function (statusAtual, statusItem) {
    if (statusAtual !== this.status.PENDENCIA_ADM) return false
    if (statusItem.value == this.status.CADASTRO) return true
    if (statusItem.value == this.status.PENDENCIA_ADM) return true
    if (statusItem.value >= this.status.SOLICITAR_PERICIA && statusItem.value <= this.status.PERICIA_RECEBIDA) return true
    if (statusItem.value == this.status.EM_ANALISE) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_ADM_SOLICITAR_PERICIA: function (statusAtual, statusItem) {
    if (statusAtual !== this.status.SOLICITAR_PERICIA) return false
    if (statusItem.value == this.status.PENDENCIA_ADM) return true
    if (statusItem.value >= this.status.SOLICITAR_PERICIA && statusItem.value <= this.status.PERICIA_RECEBIDA) return true
    if (statusItem.value == this.status.EM_ANALISE) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_ADM_PERICIA_DISPENSADA: function (statusAtual, statusItem) {
    if (statusAtual != this.status.PERICIA_DISPENSADA) return false
    if (statusItem.value == this.status.PENDENCIA_ADM) return true
    if (statusItem.value >= this.status.SOLICITAR_PERICIA && statusItem.value <= this.status.PERICIA_RECEBIDA) return true
    if (statusItem.value == this.status.EM_ANALISE) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_ADM_PERICIA_AGENDADA: function (statusAtual, statusItem) {
    if (statusAtual != this.status.PERICIA_AGENDADA) return false
    if (statusItem.value == this.status.PENDENCIA_ADM) return true
    if (statusItem.value >= this.status.SOLICITAR_PERICIA && statusItem.value <= this.status.PERICIA_RECEBIDA) return true
    if (statusItem.value == this.status.EM_ANALISE) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_ADM_PERICIA_RECEBIDA: function (statusAtual, statusItem) {
    if (statusAtual != this.status.PERICIA_RECEBIDA) return false
    if (statusItem.value == this.status.PENDENCIA_ADM) return true
    if (statusItem.value >= this.status.SOLICITAR_PERICIA && statusItem.value <= this.status.PERICIA_RECEBIDA) return true
    if (statusItem.value == this.status.EM_ANALISE) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_ADM_PENDENCIA_DOCUMENTAL: function (statusAtual, statusItem) {
    if (statusAtual != this.status.PENDENCIA_DOCUMENTAL) return false
    if (statusItem.value == this.status.PENDENCIA_ADM) return true
    if (statusItem.value >= this.status.SOLICITAR_PERICIA && statusItem.value <= this.status.PERICIA_RECEBIDA) return true
    if (statusItem.value == this.status.PENDENCIA_DOCUMENTAL) return true
    if (statusItem.value == this.status.EM_ANALISE) return true
    if (statusItem.value == this.status.PAGO) return true
    if (statusItem.value == this.status.NEGADO) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_ADM_EM_ANALISE: function (statusAtual, statusItem) {
    if (statusAtual != this.status.EM_ANALISE) return false
    if (statusItem.value == this.status.PENDENCIA_ADM) return true
    if (statusItem.value >= this.status.SOLICITAR_PERICIA && statusItem.value <= this.status.PERICIA_RECEBIDA) return true
    if (statusItem.value == this.status.PENDENCIA_DOCUMENTAL) return true
    if (statusItem.value == this.status.EM_ANALISE) return true
    if (statusItem.value == this.status.PAGO) return true
    if (statusItem.value == this.status.NEGADO) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_ADM_NEGADO: function (statusAtual, statusItem) {
    if (statusAtual != this.status.NEGADO) return false
    if (statusItem.value == this.status.EM_ANALISE) return true
    if (statusItem.value == this.status.NEGADO) return true
    return false
  },

  validaStatus_ADM_PAGO: function (statusAtual, statusItem) {
    if (statusAtual != this.status.PAGO) return false
    if (statusItem.value == this.status.EM_ANALISE) return true
    if (statusItem.value == this.status.PAGO) return true
    if (statusItem.value == this.status.PAGO_HONORARIOS) return true
    if (statusItem.value == this.status.INADIMPLENTE) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_ADM_PAGO_HONORARIOS: function (statusAtual, statusItem) {
    if (statusAtual != this.status.PAGO_HONORARIOS) return false
    if (statusItem.value == this.status.EM_ANALISE) return true
    if (statusItem.value == this.status.PAGO) return true
    if (statusItem.value == this.status.PAGO_HONORARIOS) return true
    if (statusItem.value == this.status.ANALISE_JURIDICA) return true
    if (statusItem.value == this.status.ARQUIVO) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_ADM_ANALISE_JURIDICA: function (statusAtual, statusItem) {
    if (statusAtual != this.status.ANALISE_JURIDICA) return false
    if (statusItem.value == this.status.PAGO_HONORARIOS) return true
    if (statusItem.value == this.status.ANALISE_JURIDICA) return true
    if (statusItem.value == this.status.ARQUIVO) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_ADM_INADIMPLENTE: function (statusAtual, statusItem) {
    if (statusAtual != this.status.INADIMPLENTE) return false
    if (statusItem.value == this.status.EM_ANALISE) return true
    if (statusItem.value == this.status.PAGO) return true
    if (statusItem.value == this.status.PAGO_HONORARIOS) return true
    if (statusItem.value == this.status.INADIMPLENTE) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_ADM_ARQUIVO: function (statusAtual, statusItem) {
    if (statusAtual != this.status.ARQUIVO) return false
    if (statusItem.value == this.status.PAGO_HONORARIOS) return true
    if (statusItem.value == this.status.ARQUIVO) return true
    return false
  },

  validaStatus_ADM_CANCELADO: function (statusAtual, statusItem) {
    if (statusAtual != this.status.CANCELADO) return false
    if (statusItem.value == this.status.PENDENCIA_ADM) return true
    if (statusItem.value >= this.status.SOLICITAR_PERICIA && statusItem.value <= this.status.PERICIA_RECEBIDA) return true
    if (statusItem.value == this.status.EM_ANALISE) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },




  //Valida e retorno STATUS quando o processo for do tipo JURÍDICO
  validaStatus_JUR_VAZIO: function (statusAtual, statusItem) {
    if (statusAtual) return false
    if (statusItem.value == this.status.CADASTRO) return true
    if (statusItem.value == this.status.PENDENCIA_JURIDICO) return true
    if (statusItem.value == this.status.PERICIA_AGENDADA) return true
    if (statusItem.value == this.status.JURIDICO_OK) return true
    if (statusItem.value == this.status.JURIDICO_DISTRIBUIR) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_JUR_CADASTRO: function (statusAtual, statusItem) {
    if (statusAtual !== this.status.CADASTRO) return false
    if (statusItem.value == this.status.CADASTRO) return true
    if (statusItem.value == this.status.PENDENCIA_JURIDICO) return true
    if (statusItem.value == this.status.PERICIA_AGENDADA) return true
    if (statusItem.value == this.status.JURIDICO_OK) return true
    if (statusItem.value == this.status.JURIDICO_DISTRIBUIR) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_JUR_PENDENCIA_JURIDICO: function (statusAtual, statusItem) {
    if (statusAtual !== this.status.PENDENCIA_JURIDICO) return false
    if (statusItem.value == this.status.PENDENCIA_JURIDICO) return true
    if (statusItem.value == this.status.PERICIA_AGENDADA) return true
    if (statusItem.value == this.status.JURIDICO_OK) return true
    if (statusItem.value == this.status.JURIDICO_DISTRIBUIR) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_JUR_PERICIA_AGENDADA: function (statusAtual, statusItem) {
    if (statusAtual != this.status.PERICIA_AGENDADA) return false
    if (statusItem.value == this.status.PENDENCIA_JURIDICO) return true
    if (statusItem.value == this.status.PERICIA_AGENDADA) return true
    if (statusItem.value == this.status.JURIDICO_OK) return true
    if (statusItem.value == this.status.JURIDICO_DISTRIBUIR) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_JUR_JURIDICO_OK: function (statusAtual, statusItem) {
    if (statusAtual !== this.status.JURIDICO_OK) return false
    if (statusItem.value == this.status.PENDENCIA_JURIDICO) return true
    if (statusItem.value == this.status.PERICIA_AGENDADA) return true
    if (statusItem.value == this.status.JURIDICO_OK) return true
    if (statusItem.value == this.status.JURIDICO_DISTRIBUIR) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },
  
  validaStatus_JUR_JURIDICO_DISTRIBUIR: function (statusAtual, statusItem) {
    if (statusAtual !== this.status.JURIDICO_DISTRIBUIR) return false
    if (statusItem.value == this.status.PENDENCIA_JURIDICO) return true
    if (statusItem.value == this.status.PERICIA_AGENDADA) return true
    if (statusItem.value == this.status.JURIDICO_OK) return true
    if (statusItem.value == this.status.JURIDICO_DISTRIBUIR) return true
    if (statusItem.value == this.status.DISTRIBUIDO) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_JUR_DISTRIBUIDO: function (statusAtual, statusItem) {
    if (statusAtual !== this.status.DISTRIBUIDO) return false
    if (statusItem.value == this.status.JURIDICO_DISTRIBUIR) return true
    if (statusItem.value == this.status.DISTRIBUIDO) return true
    if (statusItem.value == this.status.PAGO_HONORARIOS) return true
    if (statusItem.value == this.status.NEGADO) return true
    if (statusItem.value == this.status.ARQUIVO) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_JUR_PAGO_HONORARIOS: function (statusAtual, statusItem) {
    if (statusAtual != this.status.PAGO_HONORARIOS) return false
    if (statusItem.value == this.status.DISTRIBUIDO) return true
    if (statusItem.value == this.status.PAGO_HONORARIOS) return true
    if (statusItem.value == this.status.ARQUIVO) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  },

  validaStatus_JUR_NEGADO: function (statusAtual, statusItem) {
    if (statusAtual != this.status.NEGADO) return false
    if (statusItem.value == this.status.DISTRIBUIDO) return true
    if (statusItem.value == this.status.NEGADO) return true
    return false
  },

  validaStatus_JUR_ARQUIVO: function (statusAtual, statusItem) {
    if (statusAtual != this.status.ARQUIVO) return false
    if (statusItem.value == this.status.PAGO_HONORARIOS) return true
    if (statusItem.value == this.status.ARQUIVO) return true
    return false
  },

  validaStatus_JUR_CANCELADO: function (statusAtual, statusItem) {
    if (statusAtual != this.status.CANCELADO) return false
    if (statusItem.value == this.status.PENDENCIA_JURIDICO) return true
    if (statusItem.value == this.status.PERICIA_AGENDADA) return true
    if (statusItem.value == this.status.JURIDICO_OK) return true
    if (statusItem.value == this.status.JURIDICO_DISTRIBUIR) return true
    if (statusItem.value == this.status.CANCELADO) return true
    return false
  }


}


// WEBPACK FOOTER //
// ./src/utils/validaProcesso.js